<template>
	<v-dialog v-model="dialogProvaNota" max-width="800px" persistent>
		<v-card>
			<v-card-title>
				<span class="headline">{{ formTitle }}</span>
			</v-card-title>
			<v-card-text>
				<v-form ref="form">
					<v-container>
						<v-row>
							<v-col cols="12">
								<v-text-field
									v-model="editedItem.nota"
									label="Nota"
									:rules="[rules.required]"
                  v-mask="['#', '##', '###']"
								></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-textarea
									v-model="editedItem.observacao"
									label="Observação"
									rows="2"
                  :rules="[rules.max200]"
								></v-textarea>
							</v-col>
							<v-col cols="12">
								<v-switch
									v-model="editedItem.mostrar_nota"
									color="indigo"
									label="Mostrar ao aluno"
								></v-switch>
							</v-col>
						</v-row>
					</v-container>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="warning" icon @click="close()" title="Fechar formulário">
					<v-icon>fal fa-times</v-icon>
				</v-btn>
				<v-btn color="success" icon @click="save()" title="Salvar formulário">
					<v-icon>fal fa-save</v-icon>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
	inheritAttrs: false,
	props: {
    provaId: null,
    userCursoId: null,
    provaNota: undefined,
		typeForm: {
			default: 0,
		},
	},

	data() {
		return {
			server: 'user_curso',
			editedItem: {
				id: 0,
				nota: '',
				observacao: '',
				mostrar_nota: true,
			},
		}
	},
	computed: {
		...mapState(['user', 'rules', 'dialogProvaNota']),
		formTitle() {
			return this.typeForm === 0 ? 'Cadastrar' : 'Editar'
		},
	},
	created() {
		if (this.typeForm === 1) {
      this.editedItem = Object.assign({}, this.provaNota)
      this.editedItem.mostrar_nota=(this.editedItem.mostrar_nota==1)? true:false
		}
	},

	methods: {
		close() {
			this.$store.dispatch('dialogProvaNota', { value: false })
			setTimeout(() => {
				this.$emit('changeTypeForm', {
					typeForm: 0,
					hideForm: 'provaNota',
				})
			}, 300)
		},
		save() {
			if (this.$refs.form.validate()) {
				if (this.typeForm === 0) {
					let formData = new FormData()
					formData.append('menu', this.server)
					formData.append('function', 'insert_prova_nota')
					formData.append('user_id', this.user.id)
					formData.append('prova_id', this.provaId)
					formData.append('user_curso_id', this.userCursoId)
					formData.append('nota', this.editedItem.nota)
					formData.append('observacao', this.editedItem.observacao)
					formData.append('mostrar', this.editedItem.mostrar_nota)
					let vd = this
					this.$axiosPost
						.post('functions.php', formData, {
							headers: { Authorization: this.user.token }
						})
						.then(function(response) {
							if (response.data.error === 0) {
								vd.$store.dispatch('alert', {
									alertMessage: response.data.alertMessage,
									alertType: 0,
								})
								vd.$store.dispatch('searchUserCursos', { value: true })
								vd.close()
							} else {
								vd.$store.dispatch('errorServer', {
									data: response.data,
									destination: vd.$route.path,
								})
							}
						})
						.catch(function(response) {
							console.log('ERROR!! ' + response)
						})
				} else {
					let formData = new FormData()
					formData.append('menu', this.server)
					formData.append('function', 'update_prova_nota')
					formData.append('user_id', this.user.id)
					formData.append('id', this.editedItem.prova_nota_id)
					formData.append('nota', this.editedItem.nota)
					formData.append('observacao', this.editedItem.observacao)
					formData.append('mostrar', this.editedItem.mostrar_nota)
					let vd = this
					this.$axiosPost
						.post('functions.php', formData, {
							headers: { Authorization: this.user.token }
						})
						.then(function(response) {
							if (response.data.error === 0) {
								vd.close()
								vd.$store.dispatch('alert', {
									alertMessage: response.data.alertMessage,
									alertType: 0,
								})
								vd.$store.dispatch('searchUserCursos', { value: true })
							} else {
								vd.$store.dispatch('errorServer', {
									data: response.data,
									destination: vd.$route.path,
								})
							}
						})
						.catch(function(response) {
							console.log('ERROR!! ' + response)
						})
				}
			}
		},
	},
}
</script>
